import { LocationPort } from '@/domains/auth/LocationPort'
import { Outlet } from 'react-router-dom'
import { runAuthGuard } from '@/src/router/guards/runAuthGuard'
import { authPort } from '@/infra/config/beans'

const browserLocation: LocationPort = {
  currentPath: () => globalThis.location.pathname,
  currentSearch: () => globalThis.location.search ?? '',
}
export const Loader = async () => {
  return await runAuthGuard({
    auth: authPort,
    location: browserLocation,
    authPages: ['/token', '/silent-renew'],
  })
}

const Layout = () => {
  return <Outlet />
}

export default Layout
